import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {AUDIENCES_QUERY_KEY, TEMPLATES_QUERY_KEY, TRIGGER_TEMPLATE_CACHE_KEYS} from "../queryKeys";
import {ReachTemplate, ReachTemplateStatus} from "./types";

export type ReachTemplateToggleStatus = Extract<ReachTemplateStatus, "active" | "draft">;

type UpdateTemplateStatusVariables = {id: string; status: ReachTemplateToggleStatus};

const updateTemplateStatus = async ({id, status}: UpdateTemplateStatusVariables): Promise<ReachTemplate> => {
  const response = await axiosReachInstance.patch<
    ReachTemplate,
    AxiosResponse<ReachTemplate>,
    {status: ReachTemplateToggleStatus}
  >(`/templates/${id}/status`, {status});
  return response.data;
};

export const useUpdateTemplateStatus = (
  options?: BaseMutationOptions<ReachTemplate, UpdateTemplateStatusVariables>
): BaseUseMutationResult<ReachTemplate, UpdateTemplateStatusVariables> => {
  return useBaseMutation<ReachTemplate, UpdateTemplateStatusVariables>(updateTemplateStatus, {
    ...options,
    prefixKeysToInvalidate: () => [[TEMPLATES_QUERY_KEY]],
    prefixKeysToReset: () => [[AUDIENCES_QUERY_KEY], ...TRIGGER_TEMPLATE_CACHE_KEYS],
  });
};
